import { Box, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

interface EmptyStateProps {
  header: string;
  description?: string;
  imageUrl?: string;
}

const emptyStateBox: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
};

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  return (
    <Box sx={emptyStateBox}>
      <Typography>{props.header}</Typography>
      {props.description && <Typography>{props.description}</Typography>}
    </Box>
  );
};

export default EmptyState;
